import React from "react";
import DragButton from "./DragButton";

interface IProps {
  initialPosition: number;
  maxWidth: number;
  minWidth: number;
  onMouseUp: Function;
}

const TableResizer = ({
  initialPosition,
  maxWidth,
  minWidth,
  onMouseUp,
}: IProps) => {
  let elements: any = [];
  let leftScroll: any = null;
  let rightScroll: any = null;

  const getElements = () => {
    leftScroll = document.querySelector(".MuiVirtualizedTable-scroll-left");
    rightScroll = document.querySelector(".MuiVirtualizedTable-scroll-right");
    elements = document.querySelectorAll(
      ".MuiVirtualizedTable-header-left, .MuiVirtualizedTable-column-left"
    );
  };

  const resizeColumns = (leftWidth: number, rigthWidth: number) => {
    elements.forEach((el: any) => {
      const leftEl = el.parentNode;

      if (leftEl) {
        const rightEl = el.parentNode.nextSibling;

        leftEl.style.minWidth = `${leftWidth}px`;
        leftEl.style.maxWidth = `${leftWidth}px`;

        if (rightEl) {
          rightEl.style.minWidth = `${rigthWidth}px`;
          rightEl.style.maxWidth = `${rigthWidth}px`;
        }
      }
    });
  };

  const resizeScrollColumns = (leftWidth: number, rigthWidth: number) => {
    if (leftScroll) leftScroll.style.width = `${leftWidth}px`;
    if (rightScroll) rightScroll.style.width = `${rigthWidth}px`;
  };

  return (
    <DragButton
      initialPosition={initialPosition}
      maxWidth={maxWidth}
      minWidth={minWidth}
      onBeforeMouseMove={() => getElements()}
      onMouseMove={(leftWidth, rightWidth) => {
        resizeColumns(leftWidth, rightWidth);
        resizeScrollColumns(leftWidth, rightWidth);
      }}
      onMouseUp={onMouseUp}
    />
  );
};

export default TableResizer;
